import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "panel" }
const _hoisted_2 = { value: "" }
const _hoisted_3 = ["value"]
const _hoisted_4 = {
  key: 1,
  class: "form-group"
}
const _hoisted_5 = { class: "faux-label" }

import { ref, watch } from 'vue';
import { useGettext } from '@jshmrtn/vue3-gettext';
import { ErrorBag } from '@/core/common';
import { Flash } from '@/core/Flash';
import { CustomerParent, CustomerStub, useCustomer } from '@/modules/customer/Customer';
import AppFormGroup from '@/core/components/form/AppFormGroup.vue';
import AppCheck from '@/core/components/form/AppCheck.vue';
import AppSelect from '@/core/components/form/AppSelect.vue';

interface CustomerFormParentProps {
	parent: CustomerParent | null;
	errors: ErrorBag;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerFormParent',
  props: {
    parent: {},
    errors: {}
  },
  emits: [
	'update:parent',
],
  setup(__props: any, { emit: __emit }) {

const { $gettext } = useGettext();
const props = __props;
const emit = __emit;

const parentId = ref<number | null>(props.parent?.id ?? null);
const isInCorporateGroup = ref(!!props.parent);
const showSelect = ref(!isInCorporateGroup.value);
const allCorporateParents = ref<Array<CustomerStub>>([]);
let allCorporateParentsLoaded = false;

const loadCorporateParents = async () => {
	if (allCorporateParentsLoaded) {
		return;
	}

	const customerResource = useCustomer();

	try {
		allCorporateParents.value = await customerResource.getCorporateParents();
		allCorporateParentsLoaded = true;
	} catch (e) {
		Flash.danger('Kunde inte söka', null, 20000);
	}
};

const openSelect = () => {
	showSelect.value = true;
	void loadCorporateParents();
};

watch(isInCorporateGroup, (activated) => {
	if (activated) {
		showSelect.value = true;
		void loadCorporateParents();
	} else {
		parentId.value = null;
	}
});

watch(parentId, () => {
	if (parentId.value === null) {
		emit('update:parent', null);

		return;
	}

	const parent = allCorporateParents.value.find((p) => p.id === parentId.value);

	emit('update:parent', parent);
});

watch(
	() => props.parent,
	(parent) => {
		parentId.value = parent?.id ?? null;
	},
);

return (_ctx: any,_cache: any) => {
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("h2", null, [...(_cache[2] || (_cache[2] = [
      _createTextVNode("Koncern", -1)
    ]))])), [
      [_directive_translate]
    ]),
    _createVNode(AppFormGroup, {
      id: "customer_activate_corporate_group",
      label: _unref($gettext)('Är del av koncern')
    }, {
      before: _withCtx(() => [
        _createVNode(AppCheck, {
          id: "customer_activate_corporate_group",
          modelValue: isInCorporateGroup.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isInCorporateGroup).value = $event))
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["label"]),
    (isInCorporateGroup.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (showSelect.value)
            ? (_openBlock(), _createBlock(AppFormGroup, {
                key: 0,
                id: "customer_parent",
                errors: __props.errors.parent,
                label: _unref($gettext)('Koncernmoder')
              }, {
                default: _withCtx(() => [
                  _createVNode(AppSelect, {
                    id: "customer_parent",
                    modelValue: parentId.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((parentId).value = $event)),
                    modelModifiers: { number: true },
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _withDirectives((_openBlock(), _createElementBlock("option", _hoisted_2, [...(_cache[3] || (_cache[3] = [
                        _createTextVNode("(Välj)", -1)
                      ]))])), [
                        [_directive_translate]
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allCorporateParents.value, (corporateParent) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: corporateParent.id,
                          value: corporateParent.id
                        }, _toDisplayString(corporateParent.name), 9, _hoisted_3))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["errors", "label"]))
            : (__props.parent)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_5, [...(_cache[4] || (_cache[4] = [
                    _createTextVNode(" Nuvarande koncernmoder: ", -1)
                  ]))])), [
                    [_directive_translate]
                  ]),
                  _createTextVNode(" " + _toDisplayString(__props.parent.name), 1),
                  _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
                  _withDirectives((_openBlock(), _createElementBlock("button", {
                    onClick: _withModifiers(openSelect, ["prevent"])
                  }, [...(_cache[5] || (_cache[5] = [
                    _createTextVNode(" Välj ny ", -1)
                  ]))])), [
                    [_directive_translate]
                  ])
                ]))
              : _createCommentVNode("", true)
        ], 64))
      : (__props.errors.parent)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(__props.errors.parent, (error, i) => {
            return (_openBlock(), _createElementBlock("span", {
              key: i,
              class: "form-error"
            }, _toDisplayString(error), 1))
          }), 128))
        : _createCommentVNode("", true)
  ]))
}
}

})